import axios from 'axios';
import { axiosConfig, ThrowErrorMsg } from '../util';

import {
  GET_TAGS_PAGINATED,
  UPDATE_TAG,
} from '../types';
import { getRequest, putRequest } from '../../services.js/apiService';

const STAFF_API = `${process.env.REACT_APP_API_URL}/staff`;

export const updateTag = (data) => async (dispatch) => {
  try {
    const tag = await putRequest(`${STAFF_API}/tag`, data);
    dispatch({ type: UPDATE_TAG, payload: tag });

    return tag;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const getPaginateTags = (query) => async (dispatch) => {
  try {
    const params = {
      ...query,
      pageNo: query.page,
    };
    params.orderDir = params.orderDir ? ['name', params.orderDir] : [];

    const tags = await getRequest(`${STAFF_API}/tags`, params);

    dispatch({
      type:    GET_TAGS_PAGINATED,
      payload: tags,
    });

    return tags;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};
